"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serbiaTranslations = void 0;
var _types = require("../../../types");
const serbiaTranslations = exports.serbiaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Izvinjavamo se!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Nazad',
  [_types.ErrorPageTranslationKey.text]: 'Ovoj stranici  trenutno  nije moguće pristupiti',
  [_types.ErrorPageTranslationKey.notFound]: 'Strana koju želite da vidite trenutno nije u funkciji',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Stranica koju pokušavate da otvorite je ograničena i nisu ispunjeni svi kriterijumi.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Molimo kontaktirajte Oriflame tim za podršku putem e-pošte:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Traženi URL je odbijen!'
};
